const key = 'nd.search.history';
export interface GuestHistoryItem {
  timestamp: Date;
  uuid: string;
}
export function addGuestSearchHistory(item: GuestHistoryItem): void {
  try {
    const history = getGuestSearchHistory();
    if (history.find((i) => i.uuid === item.uuid)) {
      return;
    }
    history.push(item);
    while (history.length > 100) {
      history.shift();
    }
    setGuestSearchHistory(history);
  } catch {
    //
  }
}

export function setGuestSearchHistory(
  history: GuestHistoryItem[]
): GuestHistoryItem[] {
  const unique = history.filter((value, index, array) => {
    if (!value || !value.uuid || !value.timestamp) {
      return false;
    }
    const existing = array.findIndex((item) => item.uuid === value.uuid);
    if (existing === index) {
      return true;
    }
    return false;
  });

  localStorage.setItem(key, JSON.stringify(unique || []));
  return unique;
}

export function clearGuestSearchHistory(): void {
  try {
    localStorage.removeItem(key);
  } catch {
    //
  }
}

export function getGuestSearchHistory(): GuestHistoryItem[] {
  try {
    const history: GuestHistoryItem[] =
      JSON.parse(localStorage.getItem(key) || 'null') || [];
    if (!Array.isArray(history)) {
      return setGuestSearchHistory([]);
    }

    return setGuestSearchHistory(history);
  } catch {
    return [];
  }
}
